export const ANKET_PROD_URL = "https://anket.zirve-bilgisayar.com";

export function getAnketBaseUrl(): string {
  const base = process.env.VUE_APP_ANKET_URL || ANKET_PROD_URL;
  return base.replace(/\/+$/, "");
}

// Anket backend'in interaktif SSO baslatma endpoint'i (auto-login URL'i
// alinamazsa fallback; SSO session'i varsa yine sifre sorulmaz).
// source=icrapro sart: fallback yolla acilan oturum da PROGRAM-KOKENLI
// isaretlensin ki programdan cikista grace/otomatik kapanma zincirine girsin
// (aksi halde origin='sso' olur ve program-logout zincirinden kacar).
export function getAnketSsoLoginUrl(): string {
  return `${getAnketBaseUrl()}/api/auth/sso/login?source=icrapro`;
}

/**
 * Katki Paneli'ni yeni sekmede acar.
 *
 * Hem ust cubuktaki buton hem de ilk giriste cikan tanitim dialogu bu fonksiyonu
 * kullanir; pop-up engelleyici ve reverse-tabnabbing onlemleri tek yerde durur.
 * Cagiran taraf bunu DOGRUDAN click handler icinde await etmelidir; `window.open`
 * kullanici jestiyle ayni gorevde calismazsa tarayici pencereyi engeller.
 */
export async function openAnketPenceresi(http: any): Promise<void> {
  // Popup engelleyiciye takilmamak icin pencere tiklama aninda acilir.
  const anketPenceresi = window.open("", "_blank");
  // Reverse-tabnabbing'e karsi opener bagini kopar: acilan pencere ana
  // sekmeyi window.opener uzerinden yonlendiremesin.
  if (anketPenceresi) {
    anketPenceresi.opener = null;
  }
  // Access token uygulama disina cikmaz: API, SSO'dan 2 dakikalik tek
  // kullanimlik auto-login kodu alir, pencere o URL'e yonlendirilir ve
  // anket paneli kendi OAuth akisiyla sessizce acilir.
  let url = getAnketSsoLoginUrl();
  try {
    const res: any = await http.get("/api/v1/oauth/anket-login-url");
    if (res && res.data) {
      url = res.data;
    }
  } catch (e) {
    console.error("Anket auto-login URL'i alınamadı:", e);
  }
  if (anketPenceresi) {
    anketPenceresi.location.href = url;
  } else {
    // Pencere onceden acilamadiysa noopener ile ac.
    window.open(url, "_blank", "noopener");
  }
}
